module.exports = __webpack_public_path__ + "static/arcgis-51a4a2d7530a466d829e3a183bdf4449.png";